import { TableColumn, TableColumnType } from '@thehubz/client/core';
import {
  BuyoutType,
  LicenseRegion,
  MediaCategories,
  MediaLists,
  TerritoryCategories,
  TerritoryCategoriesLufthansaGroup,
  TerritoryList,
} from '@thehubz/shared/model';
import { DownloadPurposeData } from '../../../models/download-purpose-data';

export class BuyoutRightsColumnData {
  static TABLE_DEFAULT_COLUMNS: TableColumn[] = [
    {
      sequence: 1,
      columnDef: 'licenseRegion',
      header: $localize`License region`,
      class: 'w-[25%] min-w-[14rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
      options: LicenseRegion,
    },
    {
      sequence: 2,
      columnDef: 'channel',
      header: $localize`Channel`,
      class: 'w-[20%] min-w-[10rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
      options: DownloadPurposeData.lists,
    },
    {
      sequence: 1,
      columnDef: 'buyoutType',
      header: $localize`Buyout type`,
      class: 'w-[15%] min-w-[8rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      sticky: true,
      disableClick: true,
      options: BuyoutType,
    },
    {
      sequence: 4,
      columnDef: 'expiryDate',
      header: $localize`Expiry date`,
      type: TableColumnType.date,
      class: 'w-[20%] min-w-[9rem]',
      innerClass: '!mx-8',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
    },
  ];

  static TABLE_MAKEOS_COLUMNS: TableColumn[] = [
    {
      sequence: 1,
      columnDef: 'territory',
      header: $localize`Territory`,
      class: 'w-[25%] min-w-[14rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
      options: [...TerritoryCategories, ...TerritoryCategoriesLufthansaGroup, ...TerritoryList],
    },
    {
      sequence: 2,
      columnDef: 'media',
      header: $localize`Media`,
      class: 'w-[20%] min-w-[10rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
      options: [...MediaCategories, ...MediaLists],
    },
    {
      sequence: 3,
      columnDef: 'additionalMediaInfo',
      header: $localize`Additional media info`,
      class: 'w-[18%] min-w-[10rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      sticky: true,
      disableClick: true,
    },
    {
      sequence: 4,
      columnDef: 'startBuyout',
      header: $localize`Start buyout`,
      type: TableColumnType.date,
      class: 'w-[20%] min-w-[9rem]',
      innerClass: '!mx-8',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
    },
    {
      sequence: 5,
      columnDef: 'duration',
      header: $localize`Duration`,
      type: TableColumnType.date,
      class: 'w-[20%] min-w-[9rem]',
      innerClass: '!mx-8',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
    },
    {
      sequence: 6,
      columnDef: 'expiryDate',
      header: $localize`Expiry date`,
      type: TableColumnType.date,
      class: 'w-[20%] min-w-[9rem]',
      innerClass: '!mx-8',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
    },
  ];
}
